export const black = "#232323";
export const grayDark = "#787878";
export const gray = "#ABABAB";
export const white = "#FDFDFD";
